import { render, staticRenderFns } from "./commdsTig.vue?vue&type=template&id=e4fe56c0&scoped=true"
import script from "./commdsTig.vue?vue&type=script&lang=ts"
export * from "./commdsTig.vue?vue&type=script&lang=ts"
import style0 from "./commdsTig.vue?vue&type=style&index=0&id=e4fe56c0&prod&lang=less&scoped=true"
import style1 from "./commdsTig.vue?vue&type=style&index=1&id=e4fe56c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fe56c0",
  null
  
)

export default component.exports